export default "__VITE_ASSET__BDL4anMh__"